module.exports = "/_next/static/images/marketingWidgetSticker_ru-1e008da0191363d4106df035cc447d36.png";